export default __webpack_public_path__ + "images/assets/858fe645ccd1652d39cd19d86257bf35.svg";